export default "__VITE_ASSET__CzQ$mSfW__"